import React, { useState } from 'react';
import {
  PageWrapper, Container, LogoRow, LogoDot, LogoText,
  ChatFab, Card, Tag, InfoBox, InfoRow, Divider,
  Button, ButtonBack, ModalOverlay, ModalBox, ModalIcon,
  ModalLabel, InputWrap, Input, ErrorText, ModalDivider, TextArea,
} from './styles';
import LoadingComponent from '../../components/loading_component';
import { userRequestService } from '../../services/userRequestService';
import { suporteService } from '../../services/suporteService';
import {
  FaExclamationCircle,
  FaTimesCircle,
  FaMobileAlt,
  FaEnvelope,
  FaCommentDots,
  FaHeadset,
  FaExclamationTriangle,
  FaUser,
} from 'react-icons/fa';



const DeleteUserRequest = () => {
  const [email, setEmail] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [generalError, setGeneralError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [suporte, setSuporte] = useState({ nome: '', email: '', mensagem: '' });
  const [suporteErrors, setSuporteErrors] = useState({});
  const [suporteLoading, setSuporteLoading] = useState(false);
  const [suporteSucesso, setSuporteSucesso] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const validate = () => {
    const errors = {};
    if (!email) errors.email = 'Informe o e-mail cadastrado.';
    return errors;
  };

  const handleProsseguir = () => {
    setGeneralError('');
    setFieldErrors({});
    setShowEmailModal(true);
  };

  const handleConfirm = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) { setFieldErrors(errors); return; }

    setShowEmailModal(false);
    setLoading(true);

    try {
      const result = await userRequestService.deleteOwnRequest(email);

      if (result.ok) {
        setSucesso(true);
        return;
      }

      if (result.kind === 'contact_support') {
        setShowSupportModal(true);
        return;
      }

      if (result.kind === 'validation') {
        const { error, details } = result.data;
        if (details?.email) {
          setFieldErrors({ email: details.email[0] });
        } else {
          setGeneralError(error || 'E-mail não encontrado ou solicitação não localizada.');
        }
        setShowEmailModal(true);
        return;
      }

      setGeneralError('Ocorreu um erro inesperado. Tente novamente.');
      setShowEmailModal(true);
    } catch (err) {
      setGeneralError('Não foi possível conectar ao servidor. Tente novamente.');
      console.error('❌ Erro ao cancelar solicitação:', err);
      setShowEmailModal(true);
    } finally {
      setLoading(false);
    }
  };

  const validateSuporte = () => {
    const errors = {};
    if (!suporte.nome.trim()) errors.nome = 'Informe seu nome.';
    if (!suporte.email.trim()) errors.email = 'Informe seu e-mail.';
    if (!suporte.mensagem.trim()) errors.mensagem = 'Descreva sua dúvida ou problema.';
    return errors;
  };

  const handleEnviarSuporte = async () => {
    const errors = validateSuporte();
    if (Object.keys(errors).length > 0) { setSuporteErrors(errors); return; }
    setSuporteErrors({});
    setSuporteLoading(true);

    try {
      const result = await suporteService.enviarMensagem(suporte.nome, suporte.email, suporte.mensagem);
      if (result.ok) {
        setSuporteSucesso(true);
        setSuporte({ nome: '', email: '', mensagem: '' });
      } else if (result.kind === 'rate_limit') {
        setSuporteErrors({ geral: 'Muitas tentativas. Aguarde um momento e tente de novo.' });
      } else {
        setSuporteErrors({ geral: 'Não foi possível enviar. Tente novamente.' });
      }
    } catch {
      setSuporteErrors({ geral: 'Não foi possível conectar ao servidor.' });
    } finally {
      setSuporteLoading(false);
    }
  };

  if (loading) return <LoadingComponent />;
  if (sucesso) return (
    <PageWrapper>
      <Container>
        <LogoRow>
          <LogoDot />
          <LogoText>Guardian</LogoText>
        </LogoRow>

        <Card style={{ textAlign: 'center' }}>
          <ModalIcon style={{ margin: '0 auto 16px' }}>
            <FaTimesCircle />
          </ModalIcon>
          <h2>Solicitação cancelada</h2>
          <p className="body" style={{ marginTop: '10px' }}>
            Sua solicitação de acesso foi removida com sucesso do sistema.
            Para solicitar acesso novamente, abra o aplicativo Guardian e realize um novo cadastro.
          </p>
          <Divider />
        </Card>
      </Container>

      <ChatFab onClick={() => setShowChatModal(true)}>
        <FaCommentDots />
      </ChatFab>
    </PageWrapper>
  );

  return (
    <PageWrapper>
      <Container>
        <LogoRow>
          <LogoDot />
          <LogoText>Guardian</LogoText>
        </LogoRow>

        <Card>
          <Tag><FaExclamationCircle /> Atenção</Tag>
          <h2>Cancelar solicitação de acesso</h2>
          <p className="body">
            Você está prestes a remover sua solicitação de login no aplicativo Guardian.
          </p>

          <InfoBox>
            <InfoRow>
              <FaTimesCircle />
              <span>Esta ação é <strong>permanente</strong> e não poderá ser desfeita.</span>
            </InfoRow>
            <InfoRow>
              <FaMobileAlt />
              <span>Para solicitar acesso novamente, acesse o aplicativo Guardian e realize um novo cadastro.</span>
            </InfoRow>
          </InfoBox>

          <Divider />
          <Button onClick={handleProsseguir}>Prosseguir</Button>
        </Card>
      </Container>

      <ChatFab onClick={() => setShowChatModal(true)}>
        <FaCommentDots />
      </ChatFab>

      {/* Modal suporte (FAB) */}
      {showChatModal && (
        <ModalOverlay>
          <ModalBox>
            {suporteSucesso ? (
              <>
                <ModalIcon chat><FaHeadset /></ModalIcon>
                <h3>Mensagem enviada!</h3>
                <p>Nossa equipe entrará em contato em breve.</p>
                <ModalDivider />
                <ButtonBack onClick={() => { setShowChatModal(false); setSuporteSucesso(false); }}>
                  Fechar
                </ButtonBack>
              </>
            ) : (
              <>
                <ModalIcon chat><FaHeadset /></ModalIcon>
                <h3>Entre em contato</h3>
                <p>Preencha os campos abaixo e nossa equipe responderá o mais breve possível.</p>

                <ModalLabel>Nome completo</ModalLabel>
                <InputWrap>

                  <Input
                    type="text"
                    placeholder="Seu nome"
                    value={suporte.nome}
                    onChange={(e) => setSuporte({ ...suporte, nome: e.target.value })}
                  />
                </InputWrap>
                {suporteErrors.nome && <ErrorText>{suporteErrors.nome}</ErrorText>}

                <ModalLabel>E-mail</ModalLabel>
                <InputWrap>

                  <Input
                    type="email"
                    placeholder="seu@email.com"
                    value={suporte.email}
                    onChange={(e) => setSuporte({ ...suporte, email: e.target.value })}
                  />
                </InputWrap>
                {suporteErrors.email && <ErrorText>{suporteErrors.email}</ErrorText>}

                <ModalLabel>Como podemos ajudar?</ModalLabel>
                <TextArea
                  placeholder="Descreva sua dúvida ou problema..."
                  value={suporte.mensagem}
                  onChange={(e) => setSuporte({ ...suporte, mensagem: e.target.value })}
                  maxLength={10000}
                />
                {suporteErrors.mensagem && <ErrorText>{suporteErrors.mensagem}</ErrorText>}
                {suporteErrors.geral && <ErrorText>{suporteErrors.geral}</ErrorText>}

                <ModalDivider />
                <Button onClick={handleEnviarSuporte} disabled={suporteLoading}>
                  {suporteLoading ? 'Enviando...' : 'Enviar mensagem'}
                </Button>
                <ButtonBack onClick={() => setShowChatModal(false)}>Cancelar</ButtonBack>
              </>
            )}
          </ModalBox>
        </ModalOverlay>
      )}

      {/* Modal e-mail */}
      {showEmailModal && (
        <ModalOverlay>
          <ModalBox>
            {/*<ModalTag>Confirmação de identidade</ModalTag> */}
            <ModalLabel>E-mail vinculado à solicitação</ModalLabel>
            <InputWrap>

              <Input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputWrap>
            {fieldErrors.email && <ErrorText>{fieldErrors.email}</ErrorText>}
            {generalError && <ErrorText>{generalError}</ErrorText>}
            <ModalDivider />
            <Button onClick={handleConfirm}>Confirmar cancelamento</Button>
            <ButtonBack onClick={() => setShowEmailModal(false)}>Cancelar</ButtonBack>
          </ModalBox>
        </ModalOverlay>
      )}

      {/* Modal erro 409 */}
      {showSupportModal && (
        <ModalOverlay>
          <ModalBox>
            <ModalIcon warn><FaExclamationTriangle /></ModalIcon>
            <h3>Não foi possível concluir</h3>
            <p>
              Houve um erro ao processar sua solicitação. Por favor, entre em contato
              com nossa equipe para que possamos ajudá-lo.
            </p>
            <Button onClick={() => {
              setShowSupportModal(false);
              setShowChatModal(true);
            }}>
              Entrar em contato
            </Button>
            <ModalDivider />
            <ButtonBack onClick={() => setShowSupportModal(false)}>Fechar</ButtonBack>
          </ModalBox>
        </ModalOverlay>
      )}
    </PageWrapper>
  );
};

export default DeleteUserRequest;